import { render } from "./UnCryptosNavigationMobile.vue?vue&type=template&id=5a101db5&scoped=true"
import script from "./UnCryptosNavigationMobile.vue?vue&type=script&lang=js"
export * from "./UnCryptosNavigationMobile.vue?vue&type=script&lang=js"

import "./UnCryptosNavigationMobile.vue?vue&type=style&index=0&id=5a101db5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a101db5"]])

export default __exports__